import { TypePolicies } from "@apollo/client";

import Bookmark from "./typePolicies/Bookmark";
import ConfidenceRating from "./typePolicies/ConfidenceRating";
import Course from "./typePolicies/Course";
import CourseProgress from "./typePolicies/CourseProgress";
import LastView from "./typePolicies/LastView";
import LocalStorage from "./typePolicies/LocalStorage";
import Module from "./typePolicies/Module";
import Notes from "./typePolicies/Notes";
import RosterUser from "./typePolicies/RosterUser";
import Section from "./typePolicies/Section";
import Slide from "./typePolicies/Slide";
import SlideView from "./typePolicies/SlideView";
import TrainingInstance from "./typePolicies/TrainingInstance";

export default {
  SlideView,
  Slide,
  Module,
  Section,
  Course,
  TrainingInstance,
  Notes,
  Bookmark,
  ConfidenceRating,
  LastView,
  Query: LocalStorage,
  CourseProgress,
  RosterUser,
} as TypePolicies;
